import React from 'react';
import LmsPackage from './LmsPackage';

/**
 * This component is used for displaying all LMS packages, each with different features and contents.
 */
const LmsPackages: React.FC = () => {
    return (
        <div className='justify-end col-span-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-center place-content-center gap-8 md:gap-16 mb-10'>
            <LmsPackage
                packageName="Paket Starter"
                gradientColors='bg-gradientbronze-100 via-gradientbronze-90 to-gradientbronze-80'
                textColors='text-gradientbronze-60 font-semibold my-2'
                packageContents={[
                    {
                        title: "Isi paket terdiri dari",
                        contents: ["Free Domain dan Hosting 1 Tahun",
                            "Sedia Admin",
                            "Free Konsultasi",
                            "Free Desain Logo",
                            "Free Akses Tutorial Selamanya"]
                    }]}
            />
            <LmsPackage
                packageName="Paket Basic Enterprise"
                gradientColors='bg-gradientsilver-30 via-gradientsilver-20 to-gradientsilver-15'
                textColors='text-gradientsilver-20 font-semibold my-2'
                packageContents={[
                    {
                        title: "Isi paket terdiri dari",
                        contents: ["Seluruh Isi Paket Starter",
                            "Free Desain seluruh Kebutuhan Design (5 bagian design)",
                            "Free Upload Data (peserta, materi, kelas, dll)",
                            "Free Demonstrasi and Training",
                            "Maintenance 1 Tahun"]
                    }]}
            />
            <LmsPackage
                packageName="Paket Full Enterprise"
                gradientColors='bg-gradient-to-r from-gradientgold-30 via-gradientgold-20 to-gradientgold-15'
                textColors='text-gradientgold-20 font-semibold my-2'
                packageContents={[
                    {
                        title: "Isi paket terdiri dari",
                        contents: ["Seluruh Isi Paket Basic"]
                    },
                    {
                        title: "Ditambah Sesuai Jenis Custom",
                        contents: ["Harga Kursus",
                            "Pembuatan Grafik",
                            "Turnitin Plagiarism",
                            "Kebutuhan Kelompok",
                            "Rating Mata Pelajaran",
                            "Laporan Penilaian PDF",
                            "Lab Pemrograman Coding",
                            "Turnitin Plagiarism",
                            "Integrasi Platform Meetings",
                            "Dan Sesuai Custom Lainnya"]
                    }
                ]}
            />
        </div>
    );
}
export default LmsPackages;